import { getLocalStorage } from "./getLocalStorage"

export const deleteLocalStorage = (elementDelete) => {
    const elements = getLocalStorage();
    // Find the position of the element to delete
    const indexElement = elements.findIndex(element => element === elementDelete);
    elements.splice(indexElement, 1);

    // Save new list in the localstorage
    localStorage.setItem("list", JSON.stringify(elements));
}